module.exports = __webpack_public_path__ + "img/MLOGO_red_2rgb.b359fc1f.svg";